import EmptyState from "components/EmptyState/EmptyState";
import { useEffect, useState } from "react";
import MediaQuery from "react-responsive";
import ApiDataBase from "server";
import Cardpayslip from "../../../../components/card/cardpayslip";
import Table from "../../../../components/table/table";
import useTitle from "../../../../hooks/TitleManager";

const Payslip = () => {
  useTitle({ title: "Fiches de paies" });
  const [isWaiting, setIsWaiting] = useState(true);
  const [payslips, setPayslips] = useState([]);

  useEffect(() => {
    setIsWaiting(true);

    ApiDataBase.getUserPayslips(
      {},
      (data) => {
        setPayslips(data.payslips);
        setIsWaiting(false);
      },
      (err) => {
        console.log(err);
        setPayslips([]);
        setIsWaiting(false);
      }
    );
  }, []);

  const month = {
    1: "Janvier",
    2: "Février",
    "03": "Mars",
    "04": "Avril",
    "05": "Mai",
    "06": "Juin",
    "07": "Juillet",
    "08": "Août",
    "09": "Septembre",
    10: "Octobre",
    11: "Novembre",
    12: "Décembre",
  };

  const titles = ["MOIS", "MONTANT", "DATE"];

  return (
    <>
      <MediaQuery minWidth={770}>
        {isWaiting ? (
          <>
            {[1, 2, 3, 4, 5].map((i, index) => (
              <Table
                champsBody={i}
                champsHeader={titles}
                isWaiting={isWaiting}
              />
            ))}
          </>
        ) : (
          <>
            {payslips?.length ? (
              <>
                <Table champsBody={payslips.reverse()} champsHeader={titles} />
              </>
            ) : (
              <EmptyState type={"payslip"} />
            )}
          </>
        )}
      </MediaQuery>
      <MediaQuery maxWidth={769}>
        {isWaiting ? (
          <>
            {[1, 2, 3, 4, 5].map((i, index) => (
              <Cardpayslip item={i} isWaiting={isWaiting} />
            ))}
          </>
        ) : (
          <>
            {payslips?.length > 0 ? (
              payslips?.map((item) => <Cardpayslip item={item} />)
            ) : (
              <EmptyState type={"time_sheet"} />
            )}
          </>
        )}
      </MediaQuery>
    </>
  );
};

export default Payslip;
